import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table, Message, Popup, Input, Checkbox, Button, Icon} from 'semantic-ui-react';
import {toUpperCase} from '../../../common/util/fieldsNormalization';
import {Actions} from '../../../common/actions';

const INITIAL_STATE = {
  'isOpen': false,
  'substitutes': [],
  'code': '',
  'quantity': 1,
  'principal': '',
};

class SubstituteModal extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handlePartFieldBlur = this.handlePartFieldBlur.bind(this);
  }

  renderTrigger() {
    return (
      <Popup inverted
        content='Opciones de Despiece'
        trigger={
          <Button circular className='add-button' floated='right' color='blue' size='tiny'
            icon='settings' onClick={this.openModal} />
        }
      />
    );
  }

  openModal(event) {
    event.preventDefault();
    const {current} = this.props;
    const principal = current.find((item) => item.isPrincipal);

    this.setState({
      'isOpen': true,
      'substitutes': current,
      'principal': principal ? principal.code : '',
    });

    this.props.updatePartVerificationStatus(false);
  }

  closeModal() {
    this.setState(INITIAL_STATE);
  }

  handleChange(event, data) {
    this.setState({[data.name]: data.value});
  }

  handleToggle(event, data) {
    const {principal} = this.state;
    this.setState({[data.name]: data.value === principal ? '' : data.value});
  }

  handleAddClick() {
    const {code, quantity, substitutes} = this.state;
    const {isValidPart} = this.props;

    if (code && quantity && isValidPart) {
      this.setState({
        'code': '',
        'quantity': 1,
        'substitutes': [...substitutes, {code, quantity}],
      });
    }
  }

  handleRemoveClick(partCode) {
    const {substitutes, principal} = this.state;

    this.setState({
      'substitutes': substitutes.filter((part) => part.code !== partCode),
      'principal': principal === partCode ? '' : principal,
    });
  }

  handleSaveClick() {
    const {partCode} = this.props;
    const {substitutes, principal} = this.state;

    if (substitutes.length && principal) {
      const components = substitutes.map((part) => ({...part, 'isPrincipal': part.code === principal}));

      this.props.savePartSpecialSubstitute(partCode, {components});
    }

    this.closeModal();
  }

  handleDeleteClick() {
    const {partCode} = this.props;

    this.props.deletePartSpecialSubstitute(partCode);
    this.closeModal();
  }

  handlePartFieldBlur() {
    const {code} = this.state;

    if (code) {
      this.props.getPartVerification(code.toUpperCase());
    }
  }

  disableSave() {
    const {substitutes, principal} = this.state;

    return !substitutes.length || !principal;
  }

  disableDelete() {
    const {current = []} = this.props;

    return current.length === 0;
  }

  renderRows() {
    const {substitutes, principal} = this.state;

    return substitutes.map((part) => {
      return (
        <Table.Row key={part.code}>
          <Table.Cell width='6' textAlign='left'>{toUpperCase(part.code)}</Table.Cell>
          <Table.Cell width='6' textAlign='right'>{part.quantity}</Table.Cell>
          <Table.Cell width='2' textAlign='left'>
            <Checkbox toggle
              name='principal'
              value={part.code}
              checked={part.code === principal}
              onChange={this.handleToggle}
            />
          </Table.Cell>
          <Table.Cell width='2'>
            <Icon link
              color='red'
              name='close'
              size='big'
              onClick={this.handleRemoveClick.bind(this, part.code)}
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderPartField() {
    const {code} = this.state;
    const {verifying, isValidPart} = this.props;

    return (
      <Input fluid
        name='code'
        value={code}
        error={!code || !isValidPart}
        onChange={this.handleChange}
        onBlur={this.handlePartFieldBlur}
        disabled={verifying}
      />
    );
  }

  renderMessage() {
    if (!this.props.isValidPart) {
      return (
        <Message negative>Repuesto no válido</Message>
      );
    }

    return null;
  }

  render() {
    const {code, quantity, principal} = this.state;

    return (
      <Modal
        open={this.state.isOpen}
        className='parts-master'
        trigger={this.renderTrigger()}
      >
        <Modal.Header>Despiece</Modal.Header>
        <Modal.Content>
          {this.renderMessage()}
          <Table striped>
            <Table.Header>
              <Table.Row textAlign='left'>
                <Table.HeaderCell width='6'>Repuesto</Table.HeaderCell>
                <Table.HeaderCell width='6'>Cantidad</Table.HeaderCell>
                <Table.HeaderCell width='2'>Principal</Table.HeaderCell>
                <Table.HeaderCell width='2'></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderRows()}
              <Table.Row>
                <Table.Cell width='6'>
                  {this.renderPartField()}
                </Table.Cell>
                <Table.Cell width='6' textAlign='left'>
                  <Input fluid
                    type='number'
                    min='1'
                    name='quantity'
                    value={quantity}
                    error={!quantity}
                    onChange={this.handleChange}
                  />
                </Table.Cell>
                <Table.Cell width='2' textAlign='left'>
                  <Checkbox toggle
                    name='principal'
                    value={code}
                    checked={code === principal}
                    onChange={this.handleToggle}
                  />
                </Table.Cell>
                <Table.Cell width='2'>
                  <Icon link color='blue' name='add' size='big' onClick={this.handleAddClick} /></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Modal.Content>
        <Modal.Actions>
          <Button inverted
            color='red'
            onClick={this.handleDeleteClick}
            disabled={this.disableDelete()}
          >
            Eliminar
          </Button>
          <Button secondary onClick={this.closeModal}>Cancelar</Button>
          <Button primary onClick={this.handleSaveClick} disabled={this.disableSave()}>Guardar</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const {values, isValidPart, verifying} = state.partsMaster;

  return {
    'partCode': values.partCode,
    verifying,
    isValidPart,
  };
};

const {
  savePartSpecialSubstitute,
  getPartVerification,
  updatePartVerificationStatus,
  deletePartSpecialSubstitute,
} = Actions;

export default connect(mapStateToProps, {
  savePartSpecialSubstitute,
  getPartVerification,
  updatePartVerificationStatus,
  deletePartSpecialSubstitute,
})(SubstituteModal);
